import { createContext } from 'react';

export const IsOnboardedContext = createContext(null);